/*@flow*/
import * as listing from './listing';
import streetscapeAsset from './streetscapeAsset';
import streetscapeIssue from './streetscapeIssue';
import tenant from './tenant';
import development from './development';
import event from './event';
import contact from './contact';
import building from './building';
import unit from './unit';
import property from './property';
import organization from './organization';
// import perk from './perk';
export { default as Hours } from './types/Hours';
import 'lib/loadTemplates';

export default {
  property,
  tenant,
  unit,
  contact,
  listing,
  development,
  streetscape_asset: streetscapeAsset,
  streetscape_issue: streetscapeIssue,
  event,
  building,
  organization,
  // perk,
};
